module.exports = __webpack_public_path__ + "img/ticket_loading.19adf5f3.gif";